<div class="maindiv"> 
    <simple-datagrid entityName="Mktpshopeevar" [parentRow]="parentRow" [condition]="condition" [customFields]="customFields" [customFunction]="customFunction" [callbackFunction]="callbackFunction" [disableEditCustomComponent]="true" ></simple-datagrid>
</div>